var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "far fa-code" }),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.$t("get.code")) + ":")]),
                      _vm._v(" " + _vm._s(_vm.rowData.Code))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "far fa-circle" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("get.description1")) + ":")
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.Description1))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(" "),
                      _c("b", [_vm._v(_vm._s(_vm.$t("get.status")) + ":")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rowData.StatusId
                              ? _vm.$t("insert.active")
                              : _vm.$t("insert.passive")
                          )
                      )
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  { attrs: { title: _vm.$t("insert.values") } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c(
                              "b-card",
                              { staticClass: "m-4 asc__showPage-card" },
                              [
                                _c(
                                  "b-table-simple",
                                  { attrs: { bordered: "", small: "" } },
                                  [
                                    _c(
                                      "b-thead",
                                      [
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("insert.Label.Code")
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("b-th", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.Label.Description1"
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tbody",
                                      _vm._l(_vm.rowData.LabelDetails, function(
                                        c,
                                        i
                                      ) {
                                        return _c(
                                          "b-tr",
                                          { key: i },
                                          [
                                            _c("b-td", [
                                              _vm._v(_vm._s(c.Code))
                                            ]),
                                            _vm._v(" "),
                                            _c("b-td", [
                                              _vm._v(_vm._s(c.Description1))
                                            ])
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c077eb72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c077eb72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Label/get.vue
// module id = null
// module chunks = 